export default "__VITE_ASSET__Cw2QT2II__"